export const SectionHead = ({ eyebrow, title, text, light }) => (
  <div className="max-w-2xl mb-12">
    <p className={`eyebrow ${light ? "!text-brass-300" : ""}`}>{eyebrow}</p>
    <h2 className={`mt-3 text-3xl sm:text-4xl font-semibold ${light ? "text-parchment" : "text-forest-800"}`}>{title}</h2>
    {text && <p className={`mt-4 text-sm sm:text-base leading-relaxed ${light ? "text-parchment/75" : "text-[#57645A]"}`}>{text}</p>}
  </div>
);
